import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  Game, GameStatuses, GameUser, generateArray, HandballGameLog,
  HandballGameLogTypes
} from '@mtgame/core';

@Component({
  selector: 'mtg-handball-game-timeline',
  templateUrl: './handball-game-timeline.component.html',
  styleUrls: ['./handball-game-timeline.component.scss', '../../game/styles/timeline.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HandballGameTimelineComponent implements OnChanges {
  @Input()
  game: Game;
  @Input()
  gameLogs: HandballGameLog[];
  @Input()
  gameUsers: GameUser[];
  @Input()
  sort: 'asc' | 'desc' = 'desc';
  @Input()
  fibaButton: boolean;

  gameStatuses = GameStatuses;
  periods: number[] = [];
  selectedPeriod: number;
  overtimePeriods: number[] = [];
  onlyScoreLogs: boolean;
  onlyHighlights: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.gameUsers || changes.gameLogs || changes.game) && this.gameUsers && this.gameLogs && this.game) {
      this.overtimePeriods = this.gameLogs.filter(log => log.period > this.game.handballGameConfig.periodsCount)
        .map(l => l.period)
        .filter((v, i, a) => a.indexOf(v) === i)
        .sort();
      let teamScore = 0;
      let competitorTeamScore = 0;
      const teamUserIds = this.gameUsers.filter(u => u.teamUser.teamId === this.game.team.id).map(u => u.id);
      const competitorTeamUserIds = this.gameUsers.filter(u => u.teamUser.teamId === this.game.competitorTeam.id).map(u => u.id);
      this.gameLogs = Object.assign([], this.gameLogs).reverse().map(log => {
        if (log.isScoreType()) {
          if (teamUserIds.indexOf(log.gameUserId) > -1 || (!log.gameUserId && log.teamId === this.game.team.id)) {
            teamScore = teamScore + 1;
          } else if (competitorTeamUserIds.indexOf(log.gameUserId) > -1 ||
            (!log.gameUserId && log.teamId === this.game.competitorTeam.id)
          ) {
            competitorTeamScore = competitorTeamScore + 1;
          }
        }
        log.teamScore = teamScore;
        log.competitorTeamScore = competitorTeamScore;
        return log;
      }).reverse();
      if (this.sort === 'asc') {
        this.gameLogs = this.gameLogs.reverse();
      }
    }
    if (changes.game && this.game) {
      this.periods = generateArray(this.game.handballGameConfig.periodsCount);
    }
  }

  identify(index, item) {
    return item.uniqueId;
  }

  toggleOnlyHighlights() {
    this.onlyHighlights = !this.onlyHighlights;
  }

  toggleOnlyScoreLogs() {
    this.onlyScoreLogs = !this.onlyScoreLogs;
  }

  isScoreLog(gameLog: HandballGameLog): boolean {
    return [
      HandballGameLogTypes.goal,
      HandballGameLogTypes.penalty_goal,
    ].indexOf(gameLog.logType) > -1;
  }
}
